<i18n lang='yml' src='../i18n/BookingAccommodation.yml'></i18n>
<template>
  <div v-if="active">
    <flash :message_type="message_type" :message_text="message_text"/>
    <h5 class="margin-top heading-page">
      {{$t('details')}} 
    </h5>
    <p v-if="details.exam_type_name">
      {{`${details.training_program_full_name} - ${details.exam_type_name[locale]}`}}
    </p>
    <div class="form-group mb-4">  
      <div class="row">
        <span class="offset-1 acc-check-offset col-sm-11">  
          <strong>{{ $t('accommodation_guiding_text') }}</strong>
        </span>
      </div>
    </div>
    <Form class="form-inner" ref="observer" v-slot="{ errors }" @submit="nextStep" @invalid-submit="setErrorMessage">
        <fieldset class="form-group border-bottom">
          <div class="form-group mb-4">   
            <div class="checkbox">       
              <label class="row">
                <span class="col-2 col-sm-1 acc-check">
                  <input type="checkbox" :value="1" :disabled="true" v-model="accommodations.accommodation_types.scribe"> 
                </span>
                <span class="col-10 col-sm-11" v-html="$t('scribe.label', { externalExamSchedulingLink })"></span>
              </label>
            </div>
            <div class="row">
              <span class="offset-1 acc-check-offset col-sm-11">  
                {{ $t('scribe.guiding_text') }}
              </span>
            </div>
          </div>

          <div class="form-group mb-4">   
            <div class="checkbox">       
              <label class="row">
                <span class="col-2 col-sm-1 acc-check">
                  <input type="checkbox" :value="1" :disabled="true" v-model="accommodations.accommodation_types.interpreter"> 
                </span>
                <span class="col-10 col-sm-11" v-html="$t('interpreter.label', { externalExamSchedulingLink })"></span>
              </label>
            </div>
            <div class="row">
              <span class="offset-1 acc-check-offset col-sm-11">  
                {{ $t('interpreter.guiding_text') }}
              </span>
            </div>
          </div>

            <div class="form-group mb-4">   
              <div class="checkbox">       
                <label class="row">
                  <span class="col-2 col-sm-1 acc-check">
                    <input type="checkbox" :value="checkPrivateRoom" v-model="accommodations.accommodation_types.extra_time"
                      :disabled="checkPrivateRoom">
                  </span>
                  <span class="col-10 col-sm-11">
                    {{ $t('extra_time.label') }}
                  </span>
                </label>
              </div>
              <div class="row">
                <span class="offset-1 acc-check-offset col-sm-11">  
                  {{ $t('extra_time.guiding_text') }}
                </span>
              </div>
            </div>

            <div class="form-group mb-4">   
              <div class="checkbox">      
                <label class="row">
                  <span class="col-2 col-sm-1 acc-check">
                    <input type="checkbox" 
                    :value="checkPrivateRoom" 
                    :disabled="checkPrivateRoom" 
                    v-model="accommodations.accommodation_types.private_room">
                  </span>
                  <span class="col-10 col-sm-11">
                    {{ $t('private_room.label') }}
                  </span>
                </label>
              </div>
              <div class="row">
                <span class="offset-1 acc-check-offset col-sm-11">  
                  {{ $t('private_room.guiding_text') }}
                </span>
              </div>
            </div>

            <div class="form-group mb-4">   
              <div class="checkbox">     
                <label class="row">
                  <span class="col-2 col-sm-1 acc-check">
                    <input type="checkbox" :value="1" v-model="accommodations.accommodation_types.other" @change="resetOther">
                  </span>
                  <span class="col-10 col-sm-11">
                    {{ $t('other.label') }}
                  </span>
                </label>
              </div>
              <div class="row">
                <div class="offset-1 acc-check-offset col-sm-11">
                  <div class="form group mt-3" v-if="accommodations.accommodation_types.other">
                    <div class="mb-2">
                      {{ $t('other.guiding_text') }}
                    </div>
                       <Field
                        :name="$t('other_information_field')" 
                        :rules="`required_if_selected:${accommodations.accommodation_types.other},${'accommodation_other_error'}`"
                        v-slot="{ errors, field }"
                        v-model="accommodations.additional_information">
                        <label class="w-100" :for="$t('other_information_field')">
                          {{$t('other_information_field')}}          
                          <span class="red">*</span>
                        </label>
                        <textarea :id="$t('other_information_field')" name="additional_information"  
                        :class="{'is-invalid': errors[0]}" rows="4" cols="50" class="form-control" v-bind="field" type="text"/>
                        <div class="invalid-feedback" :id="`${$t('other_information_field')}_error`" v-if="errors[0]">
                          <font-awesome-icon :icon="['far', 'exclamation-circle']" fixed-width />
                          <span>{{ errors[0] }}</span> 
                        </div>
                      </Field>        
                  </div>
                </div>
              </div>
            </div>
            <template v-if="admin == 'true'">

              <div class="form-group mb-4">   
                <div class="checkbox">       
                  <label class="row">
                    <span class="col-2 col-sm-1 acc-check">
                      <input type="checkbox" :value="1" v-model="accommodations.accommodation_types.practical_exam">
                    </span>
                    <span class="col-10 col-sm-11">
                      {{ $t('practical_exam.label') }}
                    </span>
                  </label>
                </div>
              </div>

              <div class="form-group mb-4">   
                <div class="checkbox">       
                  <label class="row">
                    <span class="col-2 col-sm-1 acc-check">
                      <input type="checkbox" :value="1" v-model="accommodations.accommodation_types.exam_over_multiple_days">
                    </span>
                    <span class="col-10 col-sm-11">
                      {{ $t('multiple_days.label') }}
                    </span>
                  </label>
                </div>
              </div>


              <div class="form-group mb-4">   
                <div class="checkbox">       
                  <label class="row">
                    <span class="col-2 col-sm-1 acc-check">
                      <input type="checkbox" :disabled="true" :value="1" v-model="accommodations.accommodation_types.electronic_reader">
                    </span>
                    <span class="col-10 col-sm-11">
                      {{ $t('electronic_readers.label') }}
                    </span>
                  </label>
                </div>
              </div>

              <div class="form-group mb-4">   
                <div class="checkbox">       
                  <label class="row">
                    <span class="col-2 col-sm-1 acc-check">
                      <input type="checkbox" :value="1" v-model="accommodations.accommodation_types.additional_personal_items">
                    </span>
                    <span class="col-10 col-sm-11">
                      {{ $t('additional_personal_items.label') }}
                    </span>
                  </label>
                </div>
              </div>
            </template>

            <div class="form-group mb-4">   
              <div class="offset-1 acc-check-offset">       
                 <label for="reason">{{$t('reason.label')}}</label>     
                  <div class="form group mt-3 ">
                    <div class="mb-3">
                      {{ $t('reason.guiding_text') }}
                    </div>
                    <textarea id="reason" name="reason" rows="4" cols="50" class="form-control"  :class="{'is-invalid': errors[0]}" v-model="accommodations.reason"/>
                  </div>
              </div>
            </div>
        </fieldset>
        <div v-if="Object.keys(errors).length > 0 && showErrorBanner" class="alert alert-danger" role="alert">
          <span class="red mr-2">
              <font-awesome-icon :icon="['far', 'exclamation-circle']"/>
            </span>
            {{ $t('error_warning') }}
          </div>
        <button type="submit" class="btn btn-primary btn-success no-shadow">
          <font-awesome-icon :icon="['fa', 'save']" />
          {{ $t('next') }}
        </button>
    </Form>
  </div>
</template>
<script>

import '../../../../javascripts/application/vee-validate-rules'
import flash from '../../../shared/flash_messages/components/Flash.vue';
import { Form, Field } from 'vee-validate'
import { setErrorMessage} from '../../../shared/typescripts/error.ts'
export default {
  components: { flash, Form, Field },
  props: ['locale', 'base_path', 'details', 'exam_types', 'active', 'admin', 'english_scheduling_link', 'french_scheduling_link'],

  data() {
    return {
      accommodations: {
        accommodation_types: {
          scribe: false,
          interpreter: false,
          extra_time: false,
          private_room: false,
          other: false,
          practical_exam: false,
          exam_over_multiple_days: false,
          electronic_reader: false,
          additional_personal_items: false
        },
        additional_information: "",
        reason: ""
      },
      message_text: [],
      message_type: "",
      responses: [],
      showErrorBanner: false,
    }
  },
  watch: {
    active(newVal) {
      if(newVal) {
        if (this.details.accommodations && (this.details.accommodations.accommodation_types.length == 0 && this.details.accommodations.reason == '')) {
          this.resetAccommodations()
        }}
      }
  },

  computed: {
    checkPrivateRoom() {
      let privateRoom = this.accommodations.accommodation_types.scribe || 
      this.accommodations.accommodation_types.interpreter || 
      this.accommodations.accommodation_types.electronic_reader
      this.accommodations.accommodation_types.extra_time = privateRoom
      this.accommodations.accommodation_types.private_room = privateRoom
      return privateRoom
    },

    externalExamSchedulingLink() {
      return this.locale === 'en' ? this.english_scheduling_link : this.french_scheduling_link;
    }
  },

  methods: {
    nextStep() {
      let selectedTypes = Object.keys(this.accommodations.accommodation_types).filter((acc_type) => {
        return this.accommodations.accommodation_types[acc_type]
      })
      this.$emit('accommodationChange', {
        'accommodations': {
          accommodation_types: selectedTypes,
          additional_information: this.accommodations.additional_information,
          reason: this.accommodations.reason
        }
      })
      this.$emit('nextStep')
    },
    resetOther() {
      if (this.accommodations.accommodation_types['other'] == false) {
        this.accommodations['additional_information'] = ""
      }
    },

    resetAccommodations() {
      this.accommodations.accommodation_types.scribe = false;
      this.accommodations.accommodation_types.interpreter =false;
      this.accommodations.accommodation_types.extra_time = false;
      this.accommodations.accommodation_types.private_room =false;
      this.accommodations.accommodation_types.other = false;
      this.accommodations.accommodation_types.practical_exam =false;
      this.accommodations.accommodation_types.exam_over_multiple_days = false;
      this.accommodations.accommodation_types.electronic_reader =false;
      this.accommodations.accommodation_types.additional_personal_items = false;
      this.accommodations.additional_information = "";
      this.accommodations.reason = "";
    },

    setErrorMessage({ valuese, errors, results }) {
      setErrorMessage(this, errors, true)
    }
  }
}
</script>
